/* ============================================================
   Özel Paketler — PDP paket seçici (Faz 1a)
   - Radio seçimine göre görsel durumu (.is-sel) günceller.
   - Seçili kademeyi window.fosPack üzerinden Faz 2 (builder) ve
     sepet entegrasyonuna açar.
   ============================================================ */
(function () {
  'use strict';

  function initPack(pack) {
    var opts = Array.prototype.slice.call(pack.querySelectorAll('.fos-opt'));
    if (!opts.length) return;
    var selectedOpt = null;
    var addToCartButton = document.getElementById('visual-add-to-cart-btn');
    var productForm = addToCartButton ? addToCartButton.closest('form') : null;
    var singleCtaMarkup = addToCartButton ? addToCartButton.innerHTML : '';
    var buildCtaLabel = pack.getAttribute('data-build-cta') || '';
    var completeCtaLabel = pack.getAttribute('data-complete-cta') || buildCtaLabel;
    var packageHandle = pack.getAttribute('data-pack-handle') || '';
    var needsCompletion = false;

    function isPackageMode() {
      return !!(
        selectedOpt &&
        (parseInt(selectedOpt.getAttribute('data-qty'), 10) || 1) > 1
      );
    }

    function syncCta(selectedQty) {
      if (!addToCartButton) return;
      var buttonArea = addToCartButton.closest('.button-area');
      if (buttonArea && buttonArea.classList.contains('is-lucky-sold-out')) return;
      if (selectedQty > 1) {
        addToCartButton.type = 'button';
        addToCartButton.dataset.fosPackageMode = 'true';
        addToCartButton.setAttribute('aria-haspopup', 'dialog');
        var packageCtaLabel = needsCompletion ? completeCtaLabel : buildCtaLabel;
        if (packageCtaLabel) addToCartButton.textContent = packageCtaLabel;
        return;
      }
      addToCartButton.type = 'submit';
      delete addToCartButton.dataset.fosPackageMode;
      addToCartButton.removeAttribute('aria-haspopup');
      addToCartButton.innerHTML = singleCtaMarkup;
    }

    function openSelectedBuilder() {
      if (!isPackageMode()) return false;
      if (window.fosBuilder && typeof window.fosBuilder.openPdpTier === 'function') {
        return window.fosBuilder.openPdpTier(selectedOpt);
      }
      selectedOpt.click();
      return true;
    }

    function syncState() {
      var selected = null;
      opts.forEach(function (opt) {
        var radio = opt.querySelector('.fos-opt__radio');
        var on = !!(radio && radio.checked);
        opt.classList.toggle('is-sel', on);
        if (on) selected = opt;
      });
      selectedOpt = selected;
      if (selected) {
        var selectedQty = parseInt(selected.getAttribute('data-qty'), 10) || 1;
        var productRoot = pack.closest('.product');
        if (productRoot) {
          productRoot.classList.toggle('is-fos-package-tier', selectedQty > 1);
        }
        pack.fosSelection = {
          handle: pack.getAttribute('data-pack-handle') || '',
          kind: pack.getAttribute('data-pack-kind') || '',
          builderCollection: pack.getAttribute('data-builder-collection') || '',
          qty: selectedQty,
          totalCents: parseInt(selected.getAttribute('data-total'), 10) || 0,
          anchorCents: parseInt(selected.getAttribute('data-anchor'), 10) || 0,
          advantageCents: parseInt(selected.getAttribute('data-advantage'), 10) || 0
        };
        // Faz 2/sepet entegrasyonu için son seçimi global tut
        window.fosPack = pack.fosSelection;
        syncCta(selectedQty);
      }
    }

    pack.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('fos-opt__radio')) {
        needsCompletion = false;
        syncState();
      }
    });

    if (addToCartButton) {
      document.addEventListener(
        'click',
        function (e) {
          var trigger = e.target && e.target.closest
            ? e.target.closest('#visual-add-to-cart-btn')
            : null;
          if (trigger !== addToCartButton || !isPackageMode()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          openSelectedBuilder();
        },
        true
      );

      if (productForm) {
        productForm.addEventListener(
          'submit',
          function (e) {
            if (!isPackageMode()) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            openSelectedBuilder();
          },
          true
        );
      }

      document.addEventListener('cart:itemAdded', function () {
        window.requestAnimationFrame(syncState);
      });
      document.addEventListener('fos:pdp-variant-changed', function () {
        window.requestAnimationFrame(syncState);
      });
      document.addEventListener('fos:pdp-package-builder-closed', function (e) {
        var detail = e.detail || {};
        var selectedQty = selectedOpt
          ? parseInt(selectedOpt.getAttribute('data-qty'), 10) || 1
          : 1;
        if (
          !isPackageMode() ||
          (detail.packageHandle &&
            packageHandle &&
            detail.packageHandle !== packageHandle) ||
          (detail.total && detail.total !== selectedQty)
        ) return;
        needsCompletion = detail.filled > 0 && detail.filled < selectedQty;
        syncCta(selectedQty);
      });
      document.addEventListener('fos:pdp-package-builder-completed', function (e) {
        var detail = e.detail || {};
        if (
          detail.packageHandle &&
          packageHandle &&
          detail.packageHandle !== packageHandle
        ) return;
        needsCompletion = false;
        syncState();
      });
    }

    syncState();
  }

  function init() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-fos-pack]'))
      .forEach(initPack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
